const HASH_ALGORITHM = 'SHA-256'

const toHex = (buffer: ArrayBuffer) => Array.from(new Uint8Array(buffer)).map(byte => byte.toString(16).padStart(2, '0')).join('')

export async function digestSpeechText(text: string): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle
  if (!subtle || typeof TextEncoder === 'undefined') { return null }

  try {
    return toHex(await subtle.digest(HASH_ALGORITHM, new TextEncoder().encode(text)))
  } catch (error) {
    return null
  }
}
